<div class="collab-banner sticky-header-banner banner-sec relative">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <div class="mx-auto whats-new-label banner-wts-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph secondary-gradient-text">
                        {{'collaboration_School.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mx-auto secondary-gradient-text">{{'collaboration_School.banner.title' | translate}}</h1>
                <p class="paragraph-global-text mw-650 text-whitish-gray">{{'collaboration_School.banner.description' | translate}}</p>
                <div class="mt-5 mb-5 mx-auto button-container">                    
                    <a class="save-btn btn cfa" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">{{'collaboration_School.banner.btnText' | translate}}   </a>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{'collaboration_School.broadCasts.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-650">{{'collaboration_School.broadCasts.description' | translate}}</p>
        </div>

        <div class="px-3 mb-5">
            <input type="search" class="search-icon form-control podcast-search" placeholder="{{'collaboration_School.broadCasts.search' | translate}}"
             [(ngModel)]="searchText" (ngModelChange)="searchPodcasts()">
        </div>

        <div class="row">
            <div class="col-lg-3 col-sm-12">
                <div class="lft-sticky-sec">
                    <p class="paragraph-global-text d-block cursor-pointer" *ngFor="let sec of sideNavigation;let i = index"
                    [ngClass]="{'primary-color' : activeIndex == i}" (click)="scrollTo('section_'+ i)">
                    <svg xmlns="http://www.w3.org/2000/svg" style="margin-right:5px;" width="15px" height="15px" viewBox="0 0 16 16" fill="none"><g [attr.fill]="activeIndex == i ? activeColor : inactiveColor"><path d="M8 3a5 5 0 100 10A5 5 0 008 3z"/><path fill-rule="evenodd" d="M0 8a8 8 0 1116 0A8 8 0 010 8zm8-6.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13z" clip-rule="evenodd"/></g></svg>
                    <span>{{sec}}</span>
                </p>
                </div>
            </div>

            <div class="col-lg-9 col-sm-12">
                 <!-- cards  -->
                <div id="section_{{sectionIdx}}" *ngFor="let section of sections; let sectionIdx = index">
                    <div class="d-flex justify-content-between mb-5">
                        <h3 class="heading-three mb-0">{{section.title}}</h3>
                        <a class="sub-heading-color" [routerLink]="'/en/collaboration-school/' + section.groupId">View all ({{section.viewAllCount}})</a>
                    </div>
                    <div class="row card-v-gap" [ngClass]="{'mb-5' : sectionIdx < sections.length - 1}" #sectionRef
                    appIntersectionObserver (intersectionChange)="onIntersectionChange($event, sectionIdx)">
                        <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let video of section.cards" (click)="viewTutorial(section, video)">
                            <div class="card podcast-card justify-content-between card-hover-effect">
                            <div>
                                <div class="podcast-img w-100">
                                    <img class="thumbnail-img" [src]="video.image" [alt]="video.title">
                                </div>
                                <div class="podcast-card-content-sec">
                                    <p class="paragraph-global-text sub-heading-color f-14"> <i class="pi pi-clock mr-2 sub-heading-color f-14"></i> {{video.duration}}</p>
                                    <h4 class="heading-four desc-2 mb-3">{{video.title}}</h4>
                                    <span class="category-tag">{{video.tag}}</span>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
  <div class="container z-index">
      <div class="sec-title text-center">
          <h2 class="heading-one text-white mx-auto">{{'collaboration_School.cfa.title' | translate}} </h2>
          <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'collaboration_School.cfa.description' | translate}}</p>

          <div class="button-container mt-4">
              <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                {{'collaboration_School.cfa.btnText' | translate}}
              </a>
          </div>
      </div>
  </div>
</div>